/**
 * Image Carousels (Bundle-Safe)
 * - Supports dynamic DOM injection
 * - Prevents double initialization
 * - Handles mobile + desktop (thumbs)
 */

function initImageCarousels(context = document) {

  /* =========================
     MOBILE SLIDER
  ========================== */
  context.querySelectorAll('.js-mobile-slider').forEach(mobileSliderEl => {
    if (mobileSliderEl.classList.contains('swiper-initialized')) return;

    const slides = mobileSliderEl.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;

    const swiper = new Swiper(mobileSliderEl, {
      loop: slideCount > 1,
      slidesPerView: 'auto',
      centeredSlides: true,
      speed: 500,
      pagination: slideCount > 1 ? {
        el: mobileSliderEl.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      on: {
        imagesReady() {
          this.update();
        }
      }
    });

    if (slideCount <= 1) {
      mobileSliderEl.classList.add('is-single-slide');
    }
  });

  /* =========================
     DESKTOP SLIDER + THUMBS
  ========================== */
  context.querySelectorAll('.js-main-slider').forEach(mainSliderEl => {
    if (mainSliderEl.classList.contains('swiper-initialized')) return;

    const gallery = mainSliderEl.closest('.product-gallery');
    if (!gallery) return;

    const thumbsSliderEl = gallery.querySelector('.js-thumbs-slider');
    if (!thumbsSliderEl) return;

    const thumbs = thumbsSliderEl.querySelectorAll('.swiper-slide');
    const totalThumbs = thumbs.length;
    const visibleThumbs = 3;

    /* --- Thumbs Swiper --- */
    const thumbsSwiper = new Swiper(thumbsSliderEl, {
      direction: 'vertical',
      slidesPerView: visibleThumbs,
      spaceBetween: 10,
      freeMode: true,
      watchSlidesProgress: true,
      mousewheel: totalThumbs > visibleThumbs,
      navigation: totalThumbs > visibleThumbs ? {
        nextEl: thumbsSliderEl.querySelector('.swiper-button-next-thumb'),
        prevEl: thumbsSliderEl.querySelector('.swiper-button-prev-thumb'),
      } : false,
      on: {
        imagesReady() {
          this.update();
        }
      }
    });

    if (totalThumbs <= visibleThumbs) {
      thumbsSliderEl.classList.add('is-single-slide');
    }

    /* --- Main Swiper --- */
    const mainSwiper = new Swiper(mainSliderEl, {
      loop: totalThumbs > 1,
      spaceBetween: 10,
      speed: 500,
      navigation: totalThumbs > 1 ? {
        nextEl: mainSliderEl.querySelector('.swiper-button-next'),
        prevEl: mainSliderEl.querySelector('.swiper-button-prev'),
      } : false,
      thumbs: {
        swiper: thumbsSwiper,
      },
      on: {
        imagesReady() {
          this.update();
        }
      }
    });

    if (totalThumbs <= 1) {
      mainSliderEl.classList.add('is-single-slide');
    }
  });
}

/* =========================
   INITIAL LOAD
========================== */
document.addEventListener('DOMContentLoaded', () => {
  initImageCarousels();
});

/* =========================
   OPTIONAL: expose for bundle tool
   (call after DOM updates)
========================== */
window.initImageCarousels = initImageCarousels;
